// Google Sheets Service - Enhanced Player Data and Utilities with Error Handling

const samplePlayerData = [
  {
    id: 1,
    firstName: 'Sarah',
    lastName: 'Johnson',
    name: 'Sarah Johnson',
    gender: 'Female',
    age: 34,
    rating: 3.125,
    totalGames: 45,
    sessionsEligible: 'All',
    lastSession: '2024-01-15'
  },
  {
    id: 2,
    firstName: 'Michael',
    lastName: 'Chen',
    name: 'Michael Chen',
    gender: 'Male',
    age: 28,
    rating: 3.687,
    totalGames: 38,
    sessionsEligible: 'All',
    lastSession: '2024-01-14'
  },
  {
    id: 3,
    firstName: 'Amanda',
    lastName: 'Taylor',
    name: 'Amanda Taylor',
    gender: 'Female',
    age: 42,
    rating: 4.234,
    totalGames: 52,
    sessionsEligible: 'All',
    lastSession: '2024-01-13'
  },
  {
    id: 4,
    firstName: 'David',
    lastName: 'Wilson',
    name: 'David Wilson',
    gender: 'Male',
    age: 31,
    rating: 3.952,
    totalGames: 67,
    sessionsEligible: 'All',
    lastSession: '2024-01-12'
  },
  {
    id: 5,
    firstName: 'Jessica',
    lastName: 'Brown',
    name: 'Jessica Brown',
    gender: 'Female',
    age: 29,
    rating: 3.850,
    totalGames: 41,
    sessionsEligible: 'All',
    lastSession: '2024-01-11'
  },
  {
    id: 6,
    firstName: 'Christopher',
    lastName: 'Davis',
    name: 'Christopher Davis',
    gender: 'Male',
    age: 35,
    rating: 4.100,
    totalGames: 58,
    sessionsEligible: 'All',
    lastSession: '2024-01-10'
  },
  {
    id: 7,
    firstName: 'Emily',
    lastName: 'Miller',
    name: 'Emily Miller',
    gender: 'Female',
    age: 26,
    rating: 3.300,
    totalGames: 23,
    sessionsEligible: 'All',
    lastSession: '2024-01-09'
  },
  {
    id: 8,
    firstName: 'Matthew',
    lastName: 'Garcia',
    name: 'Matthew Garcia',
    gender: 'Male',
    age: 33,
    rating: 4.200,
    totalGames: 72,
    sessionsEligible: 'All',
    lastSession: '2024-01-08'
  },
  {
    id: 9,
    firstName: 'Lisa',
    lastName: 'Thomas',
    name: 'Lisa Thomas',
    gender: 'Female',
    age: 37,
    rating: 3.500,
    totalGames: 29,
    sessionsEligible: 'All',
    lastSession: '2024-01-07'
  },
  {
    id: 10,
    firstName: 'Daniel',
    lastName: 'Jackson',
    name: 'Daniel Jackson',
    gender: 'Male',
    age: 40,
    rating: 3.750,
    totalGames: 55,
    sessionsEligible: 'All',
    lastSession: '2024-01-06'
  },
  {
    id: 11,
    firstName: 'Michelle',
    lastName: 'White',
    name: 'Michelle White',
    gender: 'Female',
    age: 32,
    rating: 3.900,
    totalGames: 48,
    sessionsEligible: 'All',
    lastSession: '2024-01-05'
  },
  {
    id: 12,
    firstName: 'Anthony',
    lastName: 'Harris',
    name: 'Anthony Harris',
    gender: 'Male',
    age: 27,
    rating: 3.625,
    totalGames: 34,
    sessionsEligible: 'All',
    lastSession: '2024-01-04'
  },
  {
    id: 13,
    firstName: 'James',
    lastName: 'Anderson',
    name: 'James Anderson',
    gender: 'Male',
    age: 39,
    rating: 3.910,
    totalGames: 61,
    sessionsEligible: 'All',
    lastSession: '2024-01-03'
  },
  {
    id: 14,
    firstName: 'Stephanie',
    lastName: 'Robinson',
    name: 'Stephanie Robinson',
    gender: 'Female',
    age: 30,
    rating: 3.900,
    totalGames: 42,
    sessionsEligible: 'All',
    lastSession: '2024-01-02'
  },
  {
    id: 15,
    firstName: 'Brandon',
    lastName: 'Martinez',
    name: 'Brandon Martinez',
    gender: 'Male',
    age: 25,
    rating: 3.500,
    totalGames: 28,
    sessionsEligible: 'All',
    lastSession: '2024-01-01'
  },
  {
    id: 16,
    firstName: 'Andrew',
    lastName: 'Clark',
    name: 'Andrew Clark',
    gender: 'Male',
    age: 36,
    rating: 4.300,
    totalGames: 79,
    sessionsEligible: 'All',
    lastSession: '2023-12-31'
  },
  {
    id: 17,
    firstName: 'Kimberly',
    lastName: 'Lewis',
    name: 'Kimberly Lewis',
    gender: 'Female',
    age: 28,
    rating: 3.400,
    totalGames: 31,
    sessionsEligible: 'All',
    lastSession: '2023-12-30'
  },
  {
    id: 18,
    firstName: 'Kevin',
    lastName: 'Walker',
    name: 'Kevin Walker',
    gender: 'Male',
    age: 41,
    rating: 3.800,
    totalGames: 56,
    sessionsEligible: 'All',
    lastSession: '2023-12-29'
  },
  {
    id: 19,
    firstName: 'Jennifer',
    lastName: 'Hall',
    name: 'Jennifer Hall',
    gender: 'Female',
    age: 33,
    rating: 4.100,
    totalGames: 64,
    sessionsEligible: 'All',
    lastSession: '2023-12-28'
  },
  {
    id: 20,
    firstName: 'Ryan',
    lastName: 'Allen',
    name: 'Ryan Allen',
    gender: 'Male',
    age: 24,
    rating: 3.200,
    totalGames: 19,
    sessionsEligible: 'All',
    lastSession: '2023-12-27'
  },
  {
    id: 21,
    firstName: 'Nicole',
    lastName: 'Young',
    name: 'Nicole Young',
    gender: 'Female',
    age: 35,
    rating: 3.700,
    totalGames: 47,
    sessionsEligible: 'All',
    lastSession: '2023-12-26'
  },
  {
    id: 22,
    firstName: 'Mark',
    lastName: 'King',
    name: 'Mark King',
    gender: 'Male',
    age: 38,
    rating: 4.000,
    totalGames: 53,
    sessionsEligible: 'All',
    lastSession: '2023-12-25'
  },
  {
    id: 23,
    firstName: 'Ashley',
    lastName: 'Wright',
    name: 'Ashley Wright',
    gender: 'Female',
    age: 31,
    rating: 3.700,
    totalGames: 39,
    sessionsEligible: 'All',
    lastSession: '2023-12-24'
  },
  {
    id: 24,
    firstName: 'Robert',
    lastName: 'Lopez',
    name: 'Robert Lopez',
    gender: 'Male',
    age: 44,
    rating: 4.150,
    totalGames: 68,
    sessionsEligible: 'All',
    lastSession: '2023-12-23'
  },
  {
    id: 25,
    firstName: 'Samantha',
    lastName: 'Hill',
    name: 'Samantha Hill',
    gender: 'Female',
    age: 27,
    rating: 3.600,
    totalGames: 36,
    sessionsEligible: 'All',
    lastSession: '2023-12-22'
  }
];

// Service class with enhanced methods and error handling
export const GoogleSheetsService = {
  // Generate sample data for testing
  generateSampleData() {
    console.log('Generating sample player data...');
    // Return deep copy to prevent mutation
    return samplePlayerData.map(player => ({ ...player }));
  },

  // Parse CSV text into player objects with enhanced error handling
  parseCSV(csvText) {
    console.log('Parsing CSV data...');
    
    if (!csvText || typeof csvText !== 'string') {
      throw new Error('CSV data is empty or invalid');
    }

    const lines = csvText.split('\n').filter(line => line.trim());
    if (lines.length < 2) {
      throw new Error('CSV appears to be empty or contains only headers');
    }

    console.log(`Found ${lines.length} lines in CSV`);
    
    // Parse header to understand structure
    const header = lines[0].split(',').map(h => h.trim().replace(/"/g, '').toLowerCase());
    console.log('CSV Headers:', header);
    
    const players = [];
    const errors = [];
    
    for (let i = 1; i < lines.length; i++) {
      try {
        const values = this.parseCSVLine(lines[i]);
        
        if (values.length < 2 || (!values[0] && !values[1])) {
          console.log(`Skipping line ${i + 1}: insufficient data`);
          continue;
        }

        const player = this.createPlayerFromCSVValues(values, i + 1);
        
        if (this.validatePlayer(player)) {
          players.push(player);
        } else {
          errors.push(`Line ${i + 1}: Invalid player data`);
        }
      } catch (error) {
        errors.push(`Line ${i + 1}: ${error.message}`);
        console.warn(`Error parsing line ${i + 1}:`, error.message);
      }
    }

    console.log(`Successfully parsed ${players.length} players`);
    
    if (errors.length > 0) {
      console.warn('Parsing errors:', errors);
    }
    
    if (players.length === 0) {
      throw new Error('No valid players found in CSV. Please check the format and try again.');
    }

    return players;
  },

  // Enhanced CSV line parsing to handle quoted fields and commas
  parseCSVLine(line) {
    const result = [];
    let current = '';
    let inQuotes = false;
    
    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        result.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    
    result.push(current.trim());
    return result;
  },

  // Create player object from CSV values
  createPlayerFromCSVValues(values, lineNumber) {
    const firstName = (values[0] || '').replace(/"/g, '').trim();
    const lastName = (values[1] || '').replace(/"/g, '').trim();
    
    if (!firstName && !lastName) {
      throw new Error('Both first name and last name cannot be empty');
    }
    
    const name = `${firstName} ${lastName}`.trim();
    
    // Parse rating with validation
    let rating = 3.5;
    if (values[4]) {
      const parsedRating = parseFloat(values[4]);
      if (isNaN(parsedRating)) {
        console.warn(`Line ${lineNumber}: Invalid rating "${values[4]}", using default 3.5`);
      } else if (parsedRating < 1.0 || parsedRating > 6.0) {
        console.warn(`Line ${lineNumber}: Rating ${parsedRating} out of range, using default 3.5`);
      } else {
        rating = parsedRating;
      }
    }
    
    // Parse age with validation
    let age = null;
    if (values[3]) {
      const parsedAge = parseInt(values[3]);
      if (!isNaN(parsedAge) && parsedAge > 0 && parsedAge < 120) {
        age = parsedAge;
      } else {
        console.warn(`Line ${lineNumber}: Invalid age "${values[3]}", ignoring`);
      }
    }
    
    // Parse total games with validation
    let totalGames = 0;
    if (values[5]) {
      const parsedGames = parseInt(values[5]);
      if (!isNaN(parsedGames) && parsedGames >= 0) {
        totalGames = parsedGames;
      } else {
        console.warn(`Line ${lineNumber}: Invalid total games "${values[5]}", using 0`);
      }
    }

    const player = {
      id: Date.now() + lineNumber + Math.random() * 1000,
      firstName: firstName,
      lastName: lastName,
      name: name,
      gender: (values[2] || '').replace(/"/g, '').trim() || 'Not specified',
      age: age,
      rating: rating,
      totalGames: totalGames,
      sessionsEligible: (values[6] || 'All').replace(/"/g, '').trim(),
      lastSession: (values[7] || new Date().toISOString().split('T')[0]).replace(/"/g, '').trim()
    };

    return player;
  },

  // Validate player object
  validatePlayer(player) {
    if (!player.name || player.name.trim() === '') {
      return false;
    }
    
    if (!player.rating || player.rating < 1.0 || player.rating > 6.0) {
      return false;
    }
    
    return true;
  },

  // Export players to CSV format with proper escaping
  exportToCSV(players) {
    if (!players || players.length === 0) {
      throw new Error('No players to export');
    }

    const headers = ['First Name', 'Last Name', 'Gender', 'Age', 'Rating', 'Total Games', 'Sessions Eligible', 'Last Played'];
    
    const csvRows = [
      headers.join(','),
      ...players.map(player => [
        this.escapeCsvField(player.firstName || ''),
        this.escapeCsvField(player.lastName || ''),
        this.escapeCsvField(player.gender || ''),
        player.age || '',
        player.rating || 3.5,
        player.totalGames || 0,
        this.escapeCsvField(player.sessionsEligible || 'All'),
        player.lastSession || new Date().toISOString().split('T')[0]
      ].join(','))
    ];

    return csvRows.join('\n');
  },

  // Escape CSV fields that contain commas or quotes
  escapeCsvField(field) {
    if (typeof field !== 'string') {
      return field;
    }
    
    if (field.includes(',') || field.includes('"') || field.includes('\n')) {
      return `"${field.replace(/"/g, '""')}"`;
    }
    
    return field;
  },

  // Convert Google Sheets URL to CSV export URL with validation
  convertToCSVUrl(sheetsUrl) {
    if (!sheetsUrl || typeof sheetsUrl !== 'string') {
      throw new Error('Please provide a valid Google Sheets URL');
    }

    // Clean the URL
    const cleanUrl = sheetsUrl.trim();
    
    // Check if it's already a CSV export URL
    if (cleanUrl.includes('/export?format=csv')) {
      return cleanUrl;
    }
    
    // Extract sheet ID from various Google Sheets URL formats
    const patterns = [
      /\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/,  // Standard format
      /\/spreadsheets\/u\/\d+\/d\/([a-zA-Z0-9-_]+)/, // User-specific format
      /^([a-zA-Z0-9-_]+)$/ // Just the ID
    ];
    
    let sheetId = null;
    
    for (const pattern of patterns) {
      const match = cleanUrl.match(pattern);
      if (match) {
        sheetId = match[1];
        break;
      }
    }
    
    if (!sheetId) {
      throw new Error('Invalid Google Sheets URL. Please make sure you\'ve copied the correct link from Google Sheets.');
    }
    
    // Construct CSV export URL
    const csvUrl = `https://docs.google.com/spreadsheets/d/${sheetId}/export?format=csv`;
    console.log('Converted to CSV URL:', csvUrl);
    
    return csvUrl;
  },

  // Validate Google Sheets URL format
  isValidGoogleSheetsUrl(url) {
    if (!url || typeof url !== 'string') {
      return false;
    }
    
    const cleanUrl = url.trim();
    
    // Check for Google Sheets domain
    const hasGoogleDomain = cleanUrl.includes('docs.google.com/spreadsheets') || 
                           cleanUrl.includes('drive.google.com');
    
    // Check for sheet ID pattern
    const hasSheetId = /[a-zA-Z0-9-_]{40,}/.test(cleanUrl);
    
    return hasGoogleDomain && hasSheetId;
  },

  // Get player statistics
  getPlayerStats(players) {
    if (!players || players.length === 0) {
      return {
        total: 0,
        averageRating: 0,
        ratingRange: { min: 0, max: 0 },
        averageAge: 0,
        genderDistribution: {}
      };
    }

    const ratings = players.map(p => p.rating).filter(r => r && r > 0);
    const ages = players.map(p => p.age).filter(a => a && a > 0);
    const genders = players.map(p => p.gender || 'Not specified');

    const genderCounts = {};
    genders.forEach(gender => {
      genderCounts[gender] = (genderCounts[gender] || 0) + 1;
    });

    return {
      total: players.length,
      averageRating: ratings.length > 0 ? 
        Math.round((ratings.reduce((a, b) => a + b, 0) / ratings.length) * 100) / 100 : 0,
      ratingRange: {
        min: ratings.length > 0 ? Math.min(...ratings) : 0,
        max: ratings.length > 0 ? Math.max(...ratings) : 0
      },
      averageAge: ages.length > 0 ? 
        Math.round(ages.reduce((a, b) => a + b, 0) / ages.length) : 0,
      genderDistribution: genderCounts
    };
  }
};

// Export individual items for backward compatibility
export { samplePlayerData };
export const convertToCSVUrl = GoogleSheetsService.convertToCSVUrl;